export default {
  userDataKeyName: "thanawi-userData",
  themeSettingsKeyName: "thanawi-themeSettings",
  rememberMerKeyName: "thanawi-rememberMe",
}
